import { useState, useRef, useEffect } from 'react'

const ControlledInput = props => {
  const { InputComponent, value, onChange, ...rest } = props
  const [cursor, setCursor] = useState(null)
  const ref = useRef(null)

  useEffect(() => {
    const input = ref.current

    if (input) input.setSelectionRange(cursor, cursor)
  }, [ref, cursor, value])

  const handleChange = e => {
    setCursor(e.target.selectionStart)
    onChange && onChange(e)
  }

  return <InputComponent ref={ref} value={value} onChange={handleChange} {...rest} />
}

export default ControlledInput
